import { render, staticRenderFns } from "./loader_overlay.vue?vue&type=template&id=dd615f2a&scoped=true&lang=pug"
import script from "./loader_overlay.vue?vue&type=script&lang=js"
export * from "./loader_overlay.vue?vue&type=script&lang=js"
import style0 from "./loader_overlay.vue?vue&type=style&index=0&id=dd615f2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd615f2a",
  null
  
)

export default component.exports